<template>
  <b-modal
    id="modal-guide-notification"
    :title="$t('fleetTask.notification.guide.modalTitle')"
    size="md"
    centered
    scrollable
  >
    <h6>{{ $t('fleetTask.notification.guide.subtitle') }}</h6>

    <b-card
      v-for="(step, index) in steps"
      :key="index"
      class="border rounded shadow-sm bg-white custom-card mb-2"
    >
      <div class="d-flex">
        <div class="circle-bg d-flex align-items-center justify-content-center">
          <p>{{ index + 1 }}</p>
        </div>
        <div>
          <p>{{ step.title }}</p>

          <!-- Deskripsi -->
          <div v-for="(text, tIndex) in step.descriptions" :key="tIndex">
            <small class="text-muted">{{ text }}</small>
            <br v-if="tIndex < step.descriptions.length - 1" />
          </div>

          <!-- Link jika ada -->
          <div v-if="step.link" class="link-box">
            <a :href="step.link" target="_blank" rel="noopener noreferrer">
              {{ step.link }}
            </a>
            <button class="copy-btn" @click="copyLink(step.link)">
              <i class="icon-outline_copy"></i>
            </button>
          </div>
        </div>
      </div>
    </b-card>

    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.close')"
        @click="$bvModal.hide('modal-guide-notification')"
      />
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: { McButton },
  data() {
    return {
      waLink: 'https://wa.me/6281112517966?text=Aktifkan+Notifikasi',
      portalLink: process.env.VUE_APP_PORTAL_URL,
    }
  },
  computed: {
    steps() {
      return [
        {
          title: this.$t('fleetTask.notification.guide.steps.sendMessage.title'),
          descriptions: [
            this.$t('fleetTask.notification.guide.steps.sendMessage.description1'),
            this.$t('fleetTask.notification.guide.steps.sendMessage.description2'),
          ],
          link: this.waLink,
        },
        {
          title: this.$t('fleetTask.notification.guide.steps.activationSuccess.title'),
          descriptions: [
            this.$t('fleetTask.notification.guide.steps.activationSuccess.description1'),
          ],
        },
        {
          title: this.$t('fleetTask.notification.guide.steps.openDeliveryHub.title'),
          descriptions: [
            this.$t('fleetTask.notification.guide.steps.openDeliveryHub.description1'),
            this.$t('fleetTask.notification.guide.steps.openDeliveryHub.description2'),
          ],
          link: this.portalLink,
        },
      ]
    },
  },
  methods: {
    copyLink(link) {
      navigator.clipboard.writeText(link)
      this.$mcToast.success(this.$t('fleetTask.notification.guide.copySuccess'))
    },
  },
}
</script>

<style lang="scss" scoped>
.circle-bg {
  margin-right: 10px;
  width: 25px;
  height: 20px;
  background-color: $cyan-100;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  p {
    margin: 0;
    color: $blue;
  }
}

.custom-card {
  margin-bottom: 0;
  .card-body {
    padding: 10px !important;
  }
  small.text-muted {
    position: relative;
    top: -14px;
  }
}

.link-box {
  margin-top: -10px;
  display: flex;
  align-items: center;
  background-color: $cyan-100;
  padding: 0 5px;
  border-radius: 5px;
  width: fit-content;

  a {
    color: $cyan-500;
    text-decoration: none;
    font-size: 12px;
    margin-right: 8px;
  }

  .copy-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    margin-left: -10px;
    margin-right: -5px;
    .icon-outline_copy {
      vertical-align: middle;
      &:before {
        color: $cyan-500;
      }
    }
  }
}
</style>
